import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filters";
import scrollDirective from "@/directives/scroll";

// Yandex map
import YmapPlugin from "vue-yandex-maps";
import { settings } from "@/configs/yandexMapSettings";

// Create app
const app = createApp(App);
app.directive("scroll", scrollDirective);
app.config.globalProperties.$filters = filters;
app.use(store).use(router).use(YmapPlugin, settings).mount("#app");
